<h2 mat-dialog-title>Importing from {{jsonOrYaml}}...</h2>
<mat-dialog-content class="mat-typography"
                    (keydown.control.enter)="validateAndExit()"
                    (keydown.meta.enter)="validateAndExit()">
  <p>
    Paste your {{jsonOrYaml}} here. This should be either an object or list exported from this site.
  </p>
  <span class="mat-small">You can use <kbd>Ctrl-Enter</kbd> to save changes.</span>

  <div class="form-container">
    <mat-form-field class="text-monospace">
      <textarea matInput [placeholder]="jsonOrYaml" rows="10" [(ngModel)]="data"></textarea>
    </mat-form-field>
  </div>
  <mat-error *ngIf="error" ><div [innerHTML]="error"></div></mat-error>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="validateAndExit()">
    Import
  </button>
  <mat-spinner [diameter]="18" *ngIf="loading"></mat-spinner>
</mat-dialog-actions>
